export default __webpack_public_path__ + "static/media/Haydn higher in the air.b62ea4c9.jpg";